import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { AuthProvider } from './contexts/AuthContext'
import AuthScreen from './components/AuthScreen'
import UserProfile from './components/UserProfile'
import AccountSetupScreen from './components/AccountSetupScreen'
import DateInputScreen from './components/DateInputScreen'
import HomeScreen from './components/HomeScreen'
import ScenarioDetail from './components/ScenarioDetail'
import PaywallScreen from './components/PaywallScreen'
import PurchaseSuccessScreen from './components/PurchaseSuccessScreen'
import PremiumDashboard from './components/PremiumDashboard'
import SettingsScreen from './components/SettingsScreen'
import ProtectedRoute from './components/ProtectedRoute'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen bg-white"
          >
            <Routes>
              {/* Public Routes */}
              <Route path="/auth" element={<AuthScreen />} />
              <Route path="/account-setup" element={<AccountSetupScreen />} />
              <Route path="/setup" element={<DateInputScreen />} />
              <Route path="/" element={<HomeScreen />} />
              <Route path="/scenario/:scenarioType" element={<ScenarioDetail />} />
              <Route path="/unlock" element={<PaywallScreen />} />
              <Route path="/purchase-success" element={<PurchaseSuccessScreen />} />
              <Route path="/premium-dashboard" element={<PremiumDashboard />} />
              <Route path="/settings" element={<SettingsScreen />} />

              {/* Protected Routes */}
              <Route path="/profile" element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />

              {/* Catch all route - redirect to home */}
              <Route path="*" element={<HomeScreen />} />
            </Routes>
          </motion.div>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App